export enum QuantityUnitEnum {
  DAYS = 'DAYS',
  MEDICAL_VISIT = 'MEDICAL_VISIT',
  PCS = 'PCS',
  HOURS = 'HOURS',
  KM = 'KM'
}

export enum QuantityUnit {
  days = 'DAY',
  medicalVisit = 'MV',
  pcs = 'PCS',
  hours = 'HR',
  km = 'KM'
}
